import React from "react";
import PropTypes from "prop-types";

const FileListIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const strokeColor = stroke && stroke !== "currentColor" ? stroke : color || "#31237D";

  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <path
        d="M7.50008 1.66675H12.5001C12.9603 1.66675 13.3334 2.03984 13.3334 2.50008V4.16675C13.3334 4.62699 12.9603 5.00008 12.5001 5.00008H7.50008C7.03984 5.00008 6.66675 4.62699 6.66675 4.16675V2.50008C6.66675 2.03984 7.03984 1.66675 7.50008 1.66675V1.66675"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 3.33325H14.9999C15.9204 3.33325 16.6666 4.07944 16.6666 4.99992V16.6666C16.6666 17.5871 15.9204 18.3333 14.9999 18.3333H4.99992C4.07944 18.3333 3.33325 17.5871 3.33325 16.6666V4.99992C3.33325 4.07944 4.07944 3.33325 4.99992 3.33325H6.66659"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.16675H13.3333"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.3333H13.3333"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 9.16675H6.67508"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 13.3333H6.67508"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

FileListIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

FileListIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default FileListIcon;
